module.exports = __webpack_public_path__ + "static/media/bg_crousal.d501b7d0.svg";